import { useContext } from "react";
import { TargetApiProviderContext } from "./target-api-provider.context";

export function useTargetApiProvider() {
  const { activatedTests, sendTargetAPI } = useContext(
    TargetApiProviderContext
  );

  const checkMbox = (contentKey: string, segmentation: "A" | "B" | "C") => {
    return activatedTests[contentKey] === segmentation;
  };

  return {
    activatedTests,
    sendTargetAPI,
    checkMbox,
  };
}
